// @ts-nocheck
/* eslint-disable */
import { node, icon, text } from "~/util/dom";

export function backButton({ contentText }) {
	const con = node("button", { className: "back" });
	con.appendChild(icon("back"));
	con.appendChild(text(contentText));
	con.title = contentText;

	return con;
}
